// extracted by mini-css-extract-plugin
export default {"container":"AccountPermissions_container__xAcXb","divisor":"AccountPermissions_divisor__Yqt4W","text":"AccountPermissions_text__G1y-H"};